import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import { boardsActions } from '../../../store/boards';

// https://github.com/ashvin27/react-datatable
import ReactDatatable from '@ashvin27/react-datatable';

class Search extends React.Component {

    constructor(props) {
        super(props);

        this.query = this.getUrlParameter("q");

        this.columns = [
            {
                key: "id",
                text: "번호",
                className: "text-center",
                align: "center",
                sortable: false
            },
            {
                key: "title",
                text: "제목",
                className: "",
                align: "center",
                sortable: false,
                cell: record => {
                    return (<Link to={{ pathname: `/details/${record.category}/${record.subCategory}/${record.boardId}`, state: { ...record } }} className="g-color-black"> {record.title} </Link>);
                }
            },
            {
                key: "hit",
                text: "조회수",
                className: "text-center g-hidden-sm-down",
                align: "center",
                sortable: false
            },
            {
                key: "time",
                text: "등록일자",
                className: "text-center g-hidden-sm-down",
                sortable: false,
                align: "center",
                cell: record => {
                    return (<span> {moment(record.time).format("YYYY-MM-DD")} </span>);
                }
            }
        ];
        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50],
            no_data_text: '데이터가 없습니다!',
            language: {
                length_menu: "보기_MENU_ 페이지 당 줄수",
                filter: "검색...",
                info: "_START_ ~ _END_ / 전체: _TOTAL_ ",
                pagination: {
                    first: "처음",
                    previous: "이전",
                    next: "다음",
                    last: "마지막"
                }
            },
            show_length_menu: false,
            show_filter: true,
            show_pagination: true,
            show_info: true,
            //sort: { column: "time", order: "desc" },            
            sort: {}
        }
    }

    componentDidMount() {
        document.querySelector("main").scrollIntoView();
        this.props.getSearch(this.query);
    }

    getUrlParameter = (name) => {
        //name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        name = name.replace(/[\]]/, '\\]');
        let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        let results = regex.exec(window.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    render() {
        if (!this.props.boards && this.props.boards.length === 0) return null;
        //console.log(this.props);

        let boards = this.props.boards;
        for (let i = 0; i < boards.length; i++) {
            boards[i].id = boards.length - i;                // id key  추가
        }

        return (
            <div className="container g-pt-140 g-pb-20">
                <div className="u-heading-v3-1 g-brd-bottom g-brd-gray-light-v3 g-pt-20">
                    <h2 className="h3 u-heading-v3__title g-brd-primary g-brd-bottom-2--md g-font-size-22 g-font-weight-600 g-line-height-0_9">검색 [{this.query}]</h2>
                    <ul className="g-hidden-xs-down u-list-inline pull-right g-pt-2 g-font-size-13">
                        <li className="list-inline-item g-mr-5 g-hidden-xs-down"><Link to="/" className="u-link-v5 g-color-main">Home</Link></li>
                        <li className="list-inline-item g-color-primary"><i className="g-color-gray-light-v2 g-mr-5">/</i>검색</li>
                    </ul>
                </div>

                <div className="g-pt-30 g-pb-60">
                    <ReactDatatable className="table table-hover g-brd-y g-brd-gray-light-v3-top"
                        config={this.config}
                        records={boards}
                        columns={this.columns}
                    />
                </div>
            </div>
        )
    }
}

export default connect(
    state => state.boards,
    dispatch => bindActionCreators({ ...boardsActions }, dispatch)
)(withRouter(Search));


// WEBPACK FOOTER //
// ./src/pages/front/home/search.js